import { useEffect } from "react";

interface Params {
  codeInside?: string;
}

const Syndigo = ({ codeInside }: Params) => {
  useEffect(() => {
    const URL =
      "https://content.syndigo.com/site/8ef9426f-0b66-fce1-e06c-680274471457/tag.js?cv=";
    const tagScript = document.createElement("script");
    tagScript.type = "text/javascript";
    tagScript.async = true;
    tagScript.src = URL + Math.floor(Date.now() / 86400000);
    const tagPrimaryScript = document.getElementsByTagName("script")[0];
    tagPrimaryScript?.parentNode?.insertBefore(tagScript, tagPrimaryScript);

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (window as any).SYNDI = (window as any).SYNDI || [];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (window as any).SYNDI.push(codeInside);
  }, [codeInside]);

  return <div id="syndi_inline" />;
};

export default Syndigo;
